import { render, staticRenderFns } from "./IndxFoot.vue?vue&type=template&id=25676d58&scoped=true"
import script from "./IndxFoot.vue?vue&type=script&lang=js"
export * from "./IndxFoot.vue?vue&type=script&lang=js"
import style0 from "./IndxFoot.vue?vue&type=style&index=0&id=25676d58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25676d58",
  null
  
)

export default component.exports